module.exports = __webpack_public_path__ + "static/media/yoga.c50e39ff.png";